import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  successContentContainer: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
}));

export default useStyles;
